import moment from "moment";
import { Component } from "react";
import { getYearsFrom2020ToTillPreviousYear } from "../../../../managers/common/CommonUtil";
import RouteManager from "../../../../managers/RouteManager";
import MYReport from "./MYReport";
import { MY_REPORTS } from "./MYReportConstants";

export default class EAForm extends Component {
    data = {
        title: MY_REPORTS.EA,
        yearOptions: getYearsFrom2020ToTillPreviousYear(),
        actionBtn: ['downloadForm'],
        fields: ['year','month','userId'],
        defaultValues:{
            year: '',
            month: parseInt(moment().endOf('year').format('M')),
            formType: MY_REPORTS.EA
        }
    }
    constructor(props) {
        super(props)
        this.data.defaultValues['year']= this.data.yearOptions[0]?.id
        RouteManager.setPresenter(this);        
    }
    onButtonClick(btn) {

    }
    render() {
        return(
            <MYReport data={this.data} onButtonClick={(btn)=>{this.onButtonClick(btn)}}/>
        )
    }
}
